import { ButtonCus } from '@/components/common/Button';
import { Input } from '@/components/common/Input';
import { Label } from '@/components/common/Label';
import { useStore } from '@/hooks/useStore';
import yup from '@/services/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { flowResult } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default observer(function CouponForeverItem() {
    // hook
    const { t } = useTranslation();

    // store
    const {
        generalStore: { myAccount, getMyAccount, registerCouponForeverEnduser },
        modalStore: { showAlertModal }
    } = useStore();

    const validateSchema = yup.object().shape({
        couponCode: yup.string().trim().required('form_error_validate.required')
    });

    type FormData = yup.InferType<typeof validateSchema>;

    const form = useForm<FormData>({
        resolver: yupResolver(validateSchema),
        mode: 'onChange',
        defaultValues: {
            couponCode: ''
        }
    });

    // life cycle
    useEffect(() => {
        form.reset({
            couponCode: myAccount?.couponCode || ''
        });
    }, [myAccount?.couponCode]);

    // functions
    const onSubmit = async (data: FormData) => {
        const res = await flowResult(registerCouponForeverEnduser(data));
        if (res) {
            showAlertModal({
                id: 'register-coupon-forever-enduser-success',
                type: 'success',
                content: t('messages.register_success'),
                onClickXIcon: () => getMyAccount()
            });
        }
    };

    return (
        <div>
            <Label className='mb-2'>キャンペーンコード</Label>
            <div>
                <div className='flex items-center gap-3'>
                    <Input
                        type='text'
                        placeholder={t('placeholder.enter')}
                        disabled={!!myAccount?.couponCode}
                        {...form.register('couponCode')}
                        onKeyDown={event => event.key === 'Enter' && event.preventDefault()}
                    />
                    <ButtonCus
                        variant='outline'
                        size='xsm'
                        className='h-12'
                        type='button'
                        disabled={!!myAccount?.couponCode}
                        onClick={form.handleSubmit(onSubmit)}
                    >
                        {t('button.apply')}
                    </ButtonCus>
                </div>
            </div>
        </div>
    );
});
